function r(i) {
  return !!i && typeof i == "object" && ("topImage" in i || "title" in i || "subtitle" in i || "body" in i || "primaryButtonProps" in i || "secondaryButtonProps" in i);
}
export {
  r as isStandardContent
};
